import { MSALInstanceFactory } from '@app/security/authentication.config';
import { PublicClientApplication } from '@azure/msal-browser';

export class MsalClient {
  private static instance: PublicClientApplication;

  public static readonly getInstance = () => {

    if(!MsalClient.instance ) {
       this.instance = MSALInstanceFactory();
       this.instance.initialize();
    }
    return this.instance;
  };
}
